import React, { useState, useMemo } from 'react';
import Badge from '../UI/Badge';
import { useUser } from '../../contexts/UserContext';
import { formatConversationDate } from '../../utils/dateUtils';

const ConversationSidebar = ({
    conversations,
    activeConversationId,
    onSelectConversation,
    onNewConversation,
    searchTerm,
    onSearchChange
})=>{
    const { user } = useUser();
    const [filtro, setFiltro] = useState('todos');


      const conversacionesFiltradas = useMemo(() => {
        console.log(conversations);
        console.log(conversations.map(c => c.estado));
      if (!conversations) return [];

        switch (filtro) {
          case 'Mis pendientes':
           default:  
            return conversations.filter(c => 
              c.estado?.toLowerCase() === "activa" &&
              c.atendidaPor?.trim() === user?.nombreCompleto
            );
            
          // case 'pendientes':
          //   // estado = "activa" && atendidaPor vacío
          //   return conversations.filter(c =>
          //     c.estado?.toLowerCase() === 'activa' &&
          //     (!c.atendidaPor || c.atendidaPor.trim() === '')
          //   );

          case 'pendientes':
            return conversations.filter(c =>
              c.estado?.toLowerCase() !== 'resultado' && c.estado?.toLowerCase() !== 'cerrada'
            );

          case 'resultados':
            return conversations.filter(c =>
              c.estado?.toLowerCase() === 'resultado'
            );

          case 'atendidos':
            return conversations.filter(c =>
              c.estado?.toLowerCase() === 'activa' &&
              c.atendidaPor && c.atendidaPor.trim() !== ''
            );

          // case 'ia':
          //   // estado = "activa" && atendidaPor lleno
          //   return conversations.filter(c =>
          //     c.estado?.toLowerCase() === 'bot' &&
          //    (!c.atendidaPor || c.atendidaPor.trim() === '')
          //   );

          case 'cerrados':
            // estado = "cerrada"
            return conversations.filter(c =>
              c.estado?.toLowerCase() === 'cerrada'
            );

          case 'todos':
            return conversations;

          
        }
      }, [conversations, filtro]);




    return (
    <div className="conversation-sidebar">
      <div className='container-father-conversations'>
      <div className="sidebar-header">
        <h3>Conversaciones</h3>
        <button onClick={onNewConversation} className="new-conversation-btn">
          + Nueva
        </button>
      </div>
      <div className="search-container">
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Buscar o empezar un chat nuevo"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

        <div className='conversations-filters-container'>
           <button onClick={() => setFiltro('todos')} 
            className={`conversations-filter-btn ${filtro === 'todos' ? 'active' : ''}`}>
            Todos
          </button>
          <button onClick={() => setFiltro('Mis pendientes')} 
            className={`conversations-filter-btn ${filtro === 'Mis pendientes' ? 'active' : ''}`}>
            Mis pendientes
          </button>
          <button onClick={() => setFiltro('resultados')} 
            className={`conversations-filter-btn ${filtro === 'resultados' ? 'active' : ''}`}>
            Resultados
          </button>
          <button onClick={() => setFiltro('pendientes')}
            className={`conversations-filter-btn ${filtro === 'pendientes' ? 'active' : ''}`}>
            Pendientes
          </button>
          <button onClick={() => setFiltro('atendidos')} 
            className={`conversations-filter-btn ${filtro === 'atendidos' ? 'active' : ''}`}>
            Atendidos
          </button>
          {/* <button onClick={() => setFiltro('ia')} 
            className={`conversations-filter-btn ${filtro === 'ia' ? 'active' : ''}`}>
            IA
          </button> */}
           <button onClick={() => setFiltro('cerrados')} 
            className={`conversations-filter-btn ${filtro === 'cerrados' ? 'active': ''}`}>
            Cerrados
          </button>
          </div>
      </div>

      <div className="conversations-list">
        {/* {conversations && conversations.length > 0 ? conversations.map(conversation => ( */}
          {conversacionesFiltradas.length > 0 ? conversacionesFiltradas.map(conversation => (
          <div
            key={conversation.id}
            className={`conversation-item ${
              activeConversationId === conversation.id ? 'active' : ''
            } ${conversation.atendidaPor ? 'attended' : ''}`}
            onClick={() => onSelectConversation(conversation.id)}
          >
            <div className="conversation-info">
              <div className="contact-name">
                {conversation.numeroWhatsapp} - {conversation.nombreContacto || conversation.numeroWhatsapp}
              </div>
              <div className="last-message">
                {conversation.ultimoMensaje || 'Sin mensajes'}
              </div>
            </div>
            
            <div className="conversation-meta">
              <div className="conversation-date">
                {conversation.fechaUltimoMensaje && formatConversationDate(conversation.fechaUltimoMensaje)}
              </div>
              <Badge count={conversation.noLeidos} />
            </div>
          </div>
        )) : (
          <div className="no-conversations">
            <p>No hay conversaciones disponibles</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversationSidebar;
    